// 로그인 인증 문자 스팸함 확인 방법 — 한 곳에서만 고친다 (대표 7685, 2026-10-21)
// 규칙: 공식 안내(제조사·통신사·구글·애플 고객지원)에 적힌 메뉴 이름과 순서만 쓴다. 출처를 못 찾은 단계는 넣지 않는다.
// 출처는 2026-10-21에 읽은 페이지다(아래 각 sourceUrl). 메뉴 이름은 기기·버전마다 조금 다를 수 있다.

export interface SpamGuideGroup {
    title?: string;
    steps: string[];
    note?: string;
    sourceLabel: string;
    sourceUrl: string;
}

export interface SpamGuideSection {
    id: string;
    tab: string;
    groups: SpamGuideGroup[];
}

// 대표 7685·팀장 18:2x: 인증 문자는 솔라피(1544-4916) 또는 트윌리오(해외 번호, +1로 시작)로 간다.
export const SPAM_GUIDE_INTRO = '인증 문자는 1544-4916 또는 해외 번호(+1로 시작)로 옵니다.';

export const SPAM_GUIDE_SECTIONS: SpamGuideSection[] = [
    {
        id: 'iphone',
        tab: '아이폰',
        groups: [
            {
                title: 'iOS 26 이상',
                steps: [
                    "메시지 앱에서 '필터'를 누릅니다.",
                    "'스팸'을 누릅니다.",
                    "인증 문자를 누르고 '스팸 아님'을 누른 뒤, 받은 편지함으로 옮깁니다.",
                    "'알 수 없는 발신자' 목록도 함께 확인해 주세요.",
                ],
                sourceLabel: '애플 지원 안내',
                sourceUrl: 'https://support.apple.com/ko-kr/124159',
            },
            {
                title: 'iOS 16~18',
                steps: [
                    "메시지 앱에서 '필터'를 누릅니다.",
                    "'알 수 없는 발신자'를 눌러 인증 문자가 있는지 확인합니다.",
                ],
                note: "설정의 메시지 항목에서 '알 수 없는 발신자 필터링하기'를 켜 두면 모르는 번호의 문자가 이 목록으로 갑니다.",
                sourceLabel: '애플 iPhone 사용 설명서',
                sourceUrl: 'https://support.apple.com/ko-kr/guide/iphone/iph203ab0be4/18/ios/18',
            },
            {
                title: '스팸 차단 앱을 쓰는 경우',
                steps: [
                    "메시지 앱의 '필터' 목록에서 스팸 차단 앱이 만든 폴더도 확인해 주세요.",
                ],
                sourceLabel: '애플 iPhone 사용 설명서',
                sourceUrl: 'https://support.apple.com/ko-kr/guide/iphone/iph203ab0be4/26/ios/26',
            },
        ],
    },
    {
        id: 'galaxy',
        tab: '갤럭시',
        groups: [
            {
                title: '차단된 문자 보기',
                steps: [
                    "메시지 앱에서 '옵션 더보기'를 누릅니다.",
                    "'설정' → '스팸 및 차단 번호 관리' → '차단된 메시지'로 들어갑니다.",
                    "'차단된 악성 메시지', '인텔리전스로 차단된 메시지', '내가 차단한 메시지'에서 인증 문자를 찾습니다.",
                ],
                note: '메뉴 이름은 모델과 버전에 따라 조금 다를 수 있습니다.',
                sourceLabel: '삼성전자서비스 안내',
                sourceUrl: 'https://www.samsungsvc.co.kr/solution/3396921',
            },
            {
                title: '차단한 번호·문구 풀기',
                steps: [
                    "'스팸 및 차단 번호 관리' → '수신 차단/해제'에서 1544-4916이 있으면 오른쪽 (–)를 누릅니다.",
                    "같은 화면의 '차단 문구 관리'에 '국제발신'이나 '국외발신'이 있으면 지워 주세요. 해외 번호로 오는 인증 문자가 막힐 수 있습니다.",
                ],
                sourceLabel: '삼성전자서비스 안내',
                sourceUrl: 'https://www.samsungsvc.co.kr/solution/1487056',
            },
        ],
    },
    {
        id: 'android',
        tab: '다른 안드로이드',
        groups: [
            {
                title: '구글 메시지 앱',
                steps: [
                    '프로필 사진(또는 이니셜)을 누릅니다.',
                    "'스팸 및 차단된 메시지'를 누릅니다.",
                    "인증 문자 대화를 고르고 받은편지함으로 옮깁니다.",
                ],
                sourceLabel: '구글 메시지 고객센터',
                sourceUrl: 'https://support.google.com/messages/answer/15720740?hl=ko',
            },
            {
                title: '차단한 번호 풀기',
                steps: [
                    "프로필 사진 → 옵션 더보기 → '스팸 및 차단'으로 들어갑니다.",
                    "1544-4916을 고르고 '차단 해제'를 누릅니다.",
                ],
                sourceLabel: '구글 메시지 고객센터',
                sourceUrl: 'https://support.google.com/messages/answer/7029021?hl=ko',
            },
        ],
    },
    {
        id: 'carrier',
        tab: '통신사',
        groups: [
            {
                title: 'SKT — 문자 스팸 필터링',
                steps: [
                    "PASS 앱의 '스팸 필터링' 메뉴에서 차단된 문자를 확인합니다.",
                    '차단된 문자는 PASS 앱에서 바로 되살릴 수 있습니다(문자는 90일 안).',
                    '받고 싶은 번호를 허용 번호로 등록해 주세요.',
                ],
                sourceLabel: 'T world 안내',
                sourceUrl: 'https://www.tworld.co.kr/web/product/callplan/NA00002121',
            },
            {
                title: 'KT — 스팸차단',
                steps: [
                    "KT 스팸차단 앱에서 '전화번호 인증'으로 로그인합니다.",
                    "'스팸메시지함'에서 차단된 문자를 확인합니다.",
                    "필요한 문자가 막혔다면 허용번호를 등록하거나 '오차단신고'로 다시 받습니다.",
                ],
                sourceLabel: 'KT 고객지원 안내',
                sourceUrl: 'https://help.kt.com/servicetip/ServiceTipInfo.do?idx=994',
            },
            {
                title: 'LG U+ — 스팸차단',
                steps: [
                    'U+스팸차단 앱을 열고 로그인합니다.',
                    "'스팸 메시지함 바로가기'에서 최근 90일 동안 차단된 문자를 확인합니다.",
                    "'스팸 허용'에서 번호를 허용해 주세요.",
                ],
                sourceLabel: 'LG U+ 안내',
                sourceUrl: 'https://www.lguplus.com/mobile/plan/addon/addon-call-msg/LRZ0000277',
            },
        ],
    },
];
